export const PERMISSIONS = {
    CAN_VIEW_ADMIN_USER_DETAIL: "can_view_admin_user_detail",
    CAN_DELETE_ADMIN_USER: "can_delete_admin_user",
    CAN_VIEW_ADMIN_USERS: "can_view_admin_users",
    CAN_ONBOARD_ADMIN_USER: "can_onboard_admin_user",
    CAN_CREATE_AREA_EXECUTIVE: "can_create_area_executive",
    CAN_DELETE_AREA_EXECUTIVE: "can_delete_area_executive",
    CAN_VIEW_AREA_EXECUTIVE_DETAIL: "can_view_area_executive_detail",
    CAN_UPDATE_AREA_EXECUTIVE: "can_update_area_executive",
    CAN_VIEW_AREA_EXECUTIVES: "can_view_area_executives",
    CAN_CREATE_PART: "can_create_part",
    CAN_VIEW_PART_DETAIL: "can_view_part_detail",
    CAN_VIEW_PARTS: "can_view_parts",
    CAN_UPDATE_PART: "can_update_part",
    CAN_CREATE_ROLE_AND_PERMISSION: "can_create_role_and_permission",
    CAN_CREATE_TRAINING_MODULE: "can_create_training_module",
    CAN_VIEW_TRAINING_MODULE: "can_view_training_module",
    CAN_CREATE_TRAINING_TUTORIAL: "can_create_training_tutorial",
    CAN_CREATE_PGM_USER: "can_create_pgm_user",
    CAN_DELETE_ROLE_AND_PERMISSION: "can_delete_role_and_permission",
    CAN_GENERATE_ORDER_EXCEL: "can_generate_order_excel",
    CAN_GENERATE_PART_EXCEL: "can_generate_part_excel",
    CAN_VIEW_PGM_LIST: "can_view_pgm_list",
    CAN_VIEW_TRAINING_MODULE_DETAILS: "can_view_training_module_details",
    CAN_UPDATE_TRAINING_MODULE: "can_update_training_module",
    CAN_VIEW_TRAINING_TUTORIAL_DETAILS: "can_view_training_tutorial_details",
    CAN_VIEW_TRAINING_TUTORIALS: "can_view_training_tutorials",
    CAN_UPDATE_TRAINING_TUTORIAL: "can_update_training_tutorial",
    CAN_VIEW_ORDER_DETAILS: "can_view_order_details",
    CAN_VIEW_ORDERS: "can_view_orders",
    CAN_VIEW_PART_CATALOGUES: "can_view_part_catalogues",
    CAN_CREATE_PART_CATALOGUE: "can_create_part_catalogue",
    CAN_VIEW_PART_CATALOGUE_DETAILS: "can_view_part_catalogue_details",
    CAN_UPDATE_PART_CATALOGUE: "can_update_part_catalogue",
    CAN_VIEW_PROFILE_DETAILS: "can_view_profile_details",
    CAN_VIEW_ROLE_PERMISSION_DETAILS: "can_view_role_permission_details",
    CAN_UPDATE_ROLE_PERMISSION: "can_update_role_permission",
    CAN_PERFORM_PGM_CORRECTION: "can_perform_pgm_correction",
    CAN_PERFORM_PGM_DEACTIVATE: "can_perform_pgm_deactivate",
    CAN_UPDATE_ADMIN_USER: "can_update_admin_user",
    CAN_UPLOAD_PART_EXCEL: "can_upload_part_excel",
    CAN_VIEW_VEHICLE_CATEGORY: "can_view_vehicle_category",
    CAN_ACTIVATE_AND_DEACTIVATE_AREA_EXECUTIVE: "can_activate_and_deactivate_area_executive",
    CAN_ACTIVATE_AND_DEACTIVATE_ADMIN_USER: "can_activate_and_deactivate_admin_user",
  };
  